module.exports = __webpack_public_path__ + "img/stock5.1435e7a7.png";